export class Product {
    isSelected: boolean;
    name: string;
    productId: number;
    productCode: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/product.ts